const students = {
  pageTitle: 'छात्र',
  pageSubtitle: 'छात्र नामांकन और रिकॉर्ड प्रबंधित करें',
  totalEnrolled: 'सभी अनुभागों में कुल <strong>{{count}}</strong> छात्र नामांकित',
  studentId: 'छात्र आईडी',
  name: 'नाम',
  class: 'कक्षा',
  className: 'कक्षा / अनुभाग',
  teacherName: 'शिक्षक का नाम',
  classTeacher: 'कक्षा शिक्षक',
  dob: 'जन्म तिथि',
  fatherName: 'पिता का नाम',
  motherName: 'माता का नाम',
  contactFather: 'संपर्क (पिता)',
  contactMother: 'संपर्क (माता)',
  district: 'जिला',
  status: 'स्थिति',
  call: 'कॉल',
  enrolled: 'नामांकित',
  pending: 'लंबित',
  draft: 'ड्राफ्ट',
  inactive: 'निष्क्रिय',
  searchStudents: 'छात्र खोजें...',
  allClasses: 'सभी कक्षाएं',
  hideInactive: 'निष्क्रिय छुपाएं',
  showingInactive: 'निष्क्रिय दिखा रहे हैं',
  step1Label: 'जनसांख्यिकी',
  step2Label: 'अभिभावक विवरण',
  step3Label: 'दस्तावेज़',
  studentDemographics: 'छात्र जनसांख्यिकी',
  guardianInformation: 'अभिभावक जानकारी',
  documentUpload: 'दस्तावेज़ अपलोड',
  step1Title: 'छात्र जनसांख्यिकी',
  step2Title: 'अभिभावक / माता-पिता की जानकारी',
  step3Title: 'दस्तावेज़ अपलोड',
  saveDraft: 'ड्राफ्ट सहेजें',
  submitEnroll: 'जमा करें (नामांकन)',
  enterFullName: "छात्र का पूरा नाम दर्ज करें",
  fullResidentialAddress: 'पूरा आवासीय पता',
  selectClassSection: 'कक्षा अनुभाग चुनें',
  assignedTeacher: 'नियुक्त शिक्षक',
  noTeacherAssigned: 'कोई शिक्षक नियुक्त नहीं',
  selectClassFirst: '— पहले एक कक्षा चुनें —',
  fathersFullName: "पिता का पूरा नाम",
  mothersFullName: "माता का पूरा नाम",
  parentEmail: 'parent@email.com',
  districtName: 'जिले का नाम',
  townOrCity: 'शहर या कस्बे का नाम',
  documentsDescription: 'आवश्यक दस्तावेज़ अपलोड करें। स्वीकृत प्रारूप: PDF, JPG, PNG (अधिकतम 5 MB प्रत्येक)।',
  enrolledCount: '{{count}} छात्र नामांकित',
  enrolledCountPlural: '{{count}} छात्र नामांकित',
  backToFaculty: 'शिक्षकों पर वापस जाएं',
  unassigned: 'असाइन नहीं किया गया',
  editStudent: 'छात्र संपादित करें',
  saveChanges: 'परिवर्तन सहेजें',
  deactivate: 'निष्क्रिय करें',
  documents: 'दस्तावेज़',
  uploadedCount: '{{uploaded}} में से {{total}} अपलोड किए गए',
  requiredMissing: '({{count}} आवश्यक गुम)',
  required: 'आवश्यक',
  notUploaded: 'अपलोड नहीं किया गया',
  documentPreview: 'दस्तावेज़ पूर्वावलोकन',
  documentPreviewDescription: 'यह <strong>{{fileName}}</strong> के लिए एक पूर्वावलोकन प्लेसहोल्डर है। उत्पादन में, वास्तविक दस्तावेज़ यहां प्रस्तुत होगा।',
  pdfDocument: 'PDF दस्तावेज़',
  verified: 'सत्यापित',
  uploadDocument: 'दस्तावेज़ अपलोड करें',
  closePreview: 'पूर्वावलोकन बंद करें',
  previewDocument: 'दस्तावेज़ का पूर्वावलोकन करें',
  downloadDocument: 'दस्तावेज़ डाउनलोड करें',
  aadhaarNumber: 'आधार नंबर',
  udidNumber: 'UDID नंबर',
  emailAddress: 'ईमेल पता',
  townLabel: 'शहर / कस्बा',
  noStudentsFound: 'आपके फ़िल्टर से मेल खाने वाला कोई छात्र नहीं मिला।',
  reactivateStudent: 'छात्र को पुनः सक्रिय करें',
  confirmReactivation: 'पुनः सक्रियण की पुष्टि करें',
  reactivateConfirm: '{{name}} को पुनः सक्रिय करें?',
  addStudent: 'छात्र जोड़ें',
  callParent: 'अभिभावक को कॉल करें',
  father: 'पिता',
  mother: 'माता',
  // Alert / Incident
  alert: 'अलर्ट',
  incident: 'घटना',
  incidents: 'घटनाएं',
  incidentsOnly: 'घटनाएं ({{count}})',
  showingIncidentsOnly: 'केवल घटनाएं',
  myStudentsTitle: 'मेरे छात्र',
  myStudentsSubtitle: 'अपनी कक्षा के छात्रों को देखें और प्रबंधित करें',
  teacherTotalEnrolled: 'आपकी कक्षा में <strong>{{count}}</strong> छात्र नामांकित हैं',
};

export default students;